module.exports = __webpack_public_path__ + "img/minus.427134df.svg";